import { render, staticRenderFns } from "./ComplianceChoice.vue?vue&type=template&id=a7e1cb92&"
import script from "./ComplianceChoice.vue?vue&type=script&lang=js&"
export * from "./ComplianceChoice.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceChoice.vue?vue&type=style&index=0&id=a7e1cb92&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports